'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import {EventManager} from '../util/EventManager.js';
import {Bounds, BoxContentControl} from './BoxContent.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

class VideoResource extends EventManager {
  constructor(info){
    super();
    const pv = privateMap(this);
    // EventManager.implement(this);
    pv.size = new Point2D();
    pv.bounds = new Bounds();
    const video = domUtil.createElement('video');
    pv.video = video;

    pv.video = video;
    pv.duration = 0;

    domUtil.setAttr(video, 'preload', 'metadata');
    domUtil.setAttr(video, 'type', info.format);

    this.load = function(successCallback, params){
      const canplayHandler = (ev) => {
        domUtil.removeEventListener(video, 'error', errorHandler);
        domUtil.removeEventListener(video, 'canplay', canplayHandler);
        domUtil.removeEventListener(video, 'abort', abortHandler);
        domUtil.removeEventListener(video, 'progress', progressHandler);

        pv.duration = domUtil.getAttr(video, 'duration');
        pv.size.x = domUtil.getAttr(video, 'videoWidth');
        pv.size.y = domUtil.getAttr(video, 'videoHeight');
        domUtil.getAttr(video, 'width', pv.size.x);
        domUtil.getAttr(video, 'height', pv.size.y);
        pv.bounds.size.copy(pv.size);

        successCallback();
        if (params.always) {
          params.always();
        }
      };
      const errorHandler = (ev) => {
        domUtil.removeEventListener(video, 'error', errorHandler);
        domUtil.removeEventListener(video, 'canplay', canplayHandler);
        domUtil.removeEventListener(video, 'abort', abortHandler);
        domUtil.removeEventListener(video, 'progress', progressHandler);

        if (params.failure) {
          params.failure(ev);
        } else {
          console.error(ev);
        }
        if (params.always) {
          params.always();
        }
      };
      const abortHandler = (ev) => {
        domUtil.removeEventListener(video, 'error', errorHandler);
        domUtil.removeEventListener(video, 'canplay', canplayHandler);
        domUtil.removeEventListener(video, 'abort', abortHandler);
        domUtil.removeEventListener(video, 'progress', progressHandler);

        if (params.abort) {
          params.abort(ev);
        }
        if (params.always) {
          params.always();
        }
      };
      const progressHandler = (ev) => {
        if (params.progress) {
          params.progress(ev);
        }
      };
      domUtil.addEventListener(video, 'error', errorHandler);
      domUtil.addEventListener(video, 'canplay', canplayHandler);
      domUtil.addEventListener(video, 'abort', abortHandler);
      domUtil.addEventListener(video, 'progress', progressHandler);
      domUtil.setAttr(video, 'src', info['id']);

      return {
        abort: function(){
          console.log('TRY ABORT!');
          video.src = '';
        }
      }
    };
  }

  get type(){
    return 'video';
  }

  get size(){
    return privateMap(this).size;
  }
  get bounds(){
    return privateMap(this).bounds;
  }
  get video(){
    return privateMap(this).video;
  }
  get duration(){
    return privateMap(this).duration;
  }
  get playbackTarget(){
    return privateMap(this).video;
  }
};

export class VideoResourceLoader {
  load(source, successCallback, params){
    const resource = new VideoResource(source);
    console.log(resource);
    return resource.load(function(){
      successCallback(resource)
    }, params);
  };
}

export class VideoRenderer {
  render(view, resource, control, session){
    if (!view || !resource || !control) {
      return;
    }
    const disposition = control.box.disposition;
    const ctx = view.context2d;
    const vc = view.center;
    const z = disposition.zoom;
    const ofs = disposition.offset;
    const bounds = resource.bounds;
    const zsz = bounds.size.mul(z);
    const lt = bounds.position.mul(z).sub(zsz.div(2)).add(vc.add(ofs));
    ctx.drawImage(resource.video, lt.x, lt.y, zsz.x, zsz.y);

    if (control.playback && control.playback.playing) {
      view.requestRender();
    }
  };
};
